import type { CentralCaseRecord } from "./central-cases";

type CentralCaseChangeListener = (record: CentralCaseRecord) => void;

const listeners = new Set<CentralCaseChangeListener>();

export function publishCentralCaseChange(record: CentralCaseRecord) {
  for (const listener of listeners) listener(record);
}

export function subscribeCentralCaseChanges(listener: CentralCaseChangeListener) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
